// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// --------------------- Import Antd-Design ---------------------
import {
  Modal,
  Form,
  Input,
  Radio,
  RadioChangeEvent,
  // Select,
  DatePicker,
} from "antd";

// --------------------- Import Styles ---------------------
import { formStyle, layout, Title } from "../../ViewGerenciarPostagens/styles";

// --------------------- Import Hooks ---------------------

// --------------------- Import Uteis ---------------------
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";

// --------------------- Import dayJS ---------------------
import dayjs from "dayjs";
import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useCadastrarReserva } from "../hooks/useCadastrarReserva";
import { Reserva } from "../interfaces/Reserva";
import { IModal } from "../../../interfaces/Modal";

export default function ModalAdicionar({ isModalOpen, handleFechar }: IModal) {
  const [formReserva] = Form.useForm();

  dayjs.extend(customParseFormat);

  // Estado inicial de dos dados Lead que serão atualizados
  const [reserva, setReserva] = useState<Partial<Reserva>>({});

  const { cadastrar, isLoading, error, success, resetError } =
    useCadastrarReserva();

  // UseStates necessários para armazenar os dados que irão ser atualizados
  const [canal, setCanal] = useState<number>();

  // Função que armazena os dados alterados de Apartamento
  const reservaChange = (
    changedValues: Partial<Reserva>,
    allValues: Reserva
  ) => {
    setReserva(allValues);
  };

  // Função que armazena o dado selecionado do alugar
  const canalChange = (e: RadioChangeEvent) => {
    setCanal(e.target.value);
  };

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Sucesso
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();

  useEffect(() => {
    // Exibe a mensagem de sucesso
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);
      // Limpa estado de sucesso após 3 segundos e recarrega a página
      setTimeout(() => {
        setSuccessDisplayed(false);
        navigate(0);
      }, 3000);
    }

    // Exibe a mensagem de erro
    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    success,
    error,
    resetError,
    showSuccess,
    showError,

    errorDisplayed,
    successDisplayed,
    navigate,
  ]);

  /* eslint-disable no-template-curly-in-string */ // Constante que válida os campos de todos os  formulário
  const validarFormulario = {
    required: "${label} é necessário!",
  };
  /* eslint-enable no-template-curly-in-string */

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Cadastrar"
        onOk={() => cadastrar(reserva as Reserva)}
        confirmLoading={isLoading}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {
          <>
            <>{errorContextHolder}</>
            <>{successContextHolder}</>

            <Form
              {...layout}
              form={formReserva}
              onValuesChange={(changedValues, allValues) =>
                reservaChange(changedValues, allValues)
              }
              name="reserva"
              style={formStyle}
              validateMessages={validarFormulario}
            >
              <Title>Cadastrar Reserva</Title>

              <Form.Item
                name={["dataReserva"]}
                label="Data da Reserva "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>

              <Form.Item
                name={["idReservaOta"]}
                label="Reserva Ota "
                className="formItems"
              >
                <Input />
              </Form.Item>

              <Form.Item label="Canal" name={["canal"]} className="formItems">
                <Radio.Group onChange={canalChange} value={canal}>
                  <Radio value="AIRBNB">Airbnb</Radio>
                  <Radio value="BOOKING">Booking</Radio>
                  <Radio value="EXPEDIA">Expedia</Radio>
                  <Radio value="DECOLAR">Decolar</Radio>
                  <Radio value="MULTICOTAS">Multicotas</Radio>
                </Radio.Group>
              </Form.Item>
            </Form>
          </>
        }
      </Modal>
    </>
  );
}
